const messagesActionTypes = {
  ADD_TOAST_MESSAGE: 'ADD_TOAST_MESSAGE',
  REMOVE_TOAST_MESSAGE: 'REMOVE_TOAST_MESSAGE',
  RESET_STATE: 'RESET_STATE',
};

export { messagesActionTypes as default };
